import { toastStore } from '@skeletonlabs/skeleton';
import { defaultToastTimeout } from './constants';

const success = (message: string | unknown, timeout?: number) => {
	if (typeof message === 'string') {
		toastStore.trigger({ background: 'variant-filled-success', message, timeout: timeout || defaultToastTimeout });
	}
};
const error = (message: string | unknown, timeout?: number) => {
	if (typeof message === 'string') {
		toastStore.trigger({ background: 'variant-filled-error', message, timeout: timeout || defaultToastTimeout * 2 });
	}
};
const warning = (message: string | unknown, timeout?: number) => {
	if (typeof message === 'string') {
		toastStore.trigger({ background: 'variant-filled-warning', message, timeout: timeout || defaultToastTimeout });
	}
};

export default {
	success,
	error,
	warning
};
